var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql } from '@apollo/client';
export var PermissionAction;
(function (PermissionAction) {
    PermissionAction["MEMBERSHIPS_READ"] = "MEMBERSHIPS_READ";
    PermissionAction["MEMBERSHIPS_WRITE"] = "MEMBERSHIPS_WRITE";
    PermissionAction["ORGANIZATIONS_READ"] = "ORGANIZATIONS_READ";
    PermissionAction["ORGANIZATIONS_WRITE"] = "ORGANIZATIONS_WRITE";
})(PermissionAction || (PermissionAction = {}));
var GET_AVAILABLE_ORGANIZATIONS = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query organizations {\n    availableOrganizations @client {\n      id\n      name\n    }\n  }\n"], ["\n  query organizations {\n    availableOrganizations @client {\n      id\n      name\n    }\n  }\n"])));
export default GET_AVAILABLE_ORGANIZATIONS;
var templateObject_1;
